import { RouterModule, Routes } from '@angular/router';

import { EzApplyCreditCardComponent } from './ezapply-credit-card.component';
import { NgModule } from '@angular/core';

const ROUTES: Routes = [
	{
		path: '',
		component: EzApplyCreditCardComponent
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(ROUTES)
	],
	exports: [
		RouterModule
	],
	providers: []
})
export class EzApplyCreditCardRoutingModule {}
